// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.store-hours-container {
  padding: 20px;
  max-width: 900px;
  margin: auto;
  font-family: Arial, sans-serif;
}

.store-hours-container h2 {
  margin-bottom: 20px;
  color: #333;
}

.store-hours-section {
  margin-bottom: 30px;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #fafafa;
}

.store-hours-section h3 {
  margin-bottom: 15px;
  color: #555;
}

.store-hours-input {
  display: block;
  margin: 8px 0 15px 0;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.store-hours-button {
  padding: 8px 15px;
  background: #0077cc;
  border: none;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
}

.store-hours-button:hover {
  background: #005fa3;
}

.store-hours-delete {
  padding: 5px 10px;
  background: #d9534f;
  border: none;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 10px;
}

.store-hours-delete:hover {
  background: #c9302c;
}

.store-hours-list {
  list-style: none;
  padding: 0;
}

.store-hours-item {
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ddd;
}

.store-hours-breaks {
  margin-top: 10px;
}

.store-hours-breaks small {
  font-weight: 600;
}

.store-hours-breaks ul {
  padding-left: 20px;
  margin-top: 5px;
}

.store-hours-radio {
  margin-top: 8px;
  display: block;
}
.store-hours-container {
  padding: 0px 0px 0px 20px;
}

.store-hours-section {
  margin-bottom: 30px;
  background: #fafafa;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #ddd;
}

.store-hours-input {
  margin-bottom: 10px;
  padding: 5px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.store-hours-button {
  margin-top: 10px;
  padding: 8px 15px;
  background: #1677ff;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.store-hours-button:hover {
  background: #125fcc;
}

.store-hours-list {
  list-style: none;
  padding: 0;
}

.store-hours-item {
  margin-bottom: 15px;
  padding: 10px;
  border-bottom: 1px solid #eee;
}

.store-hours-delete {
  margin-left: 10px;
  background: #ff4d4f;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
}

.store-hours-delete:hover {
  background: #d9363e;
}

.store-hours-summary {
  list-style: none;
  padding: 0;
}

.store-hours-summary > li {
  margin-bottom: 10px;
}
.store-hours-form-container {
  display: flex;
  gap: 10px;           /* Espaço entre as seções */
  flex-wrap: wrap;     /* Permite quebrar linha se necessário */
  padding-right: 10px;
}

.store-hours-section {
  flex: 1 1 300px;    /* Cresce e encolhe, largura base 300px */
  min-width: 280px;   /* Para não ficar muito pequeno */
}

/* Mobile: empilha as seções verticalmente */
@media (max-width: 600px) {
  .store-hours-form-container {
    flex-direction: column;
  }
}


`, "",{"version":3,"sources":["webpack://./src/pages/StoreHoursManager.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS,YAAY,2BAA2B;EAChD,eAAe,MAAM,wCAAwC;EAC7D,mBAAmB;AACrB;;AAEA;EACE,eAAe,KAAK,yCAAyC;EAC7D,gBAAgB,IAAI,iCAAiC;AACvD;;AAEA,4CAA4C;AAC5C;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".store-hours-container {\r\n  padding: 20px;\r\n  max-width: 900px;\r\n  margin: auto;\r\n  font-family: Arial, sans-serif;\r\n}\r\n\r\n.store-hours-container h2 {\r\n  margin-bottom: 20px;\r\n  color: #333;\r\n}\r\n\r\n.store-hours-section {\r\n  margin-bottom: 30px;\r\n  padding: 15px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  background: #fafafa;\r\n}\r\n\r\n.store-hours-section h3 {\r\n  margin-bottom: 15px;\r\n  color: #555;\r\n}\r\n\r\n.store-hours-input {\r\n  display: block;\r\n  margin: 8px 0 15px 0;\r\n  padding: 8px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n}\r\n\r\n.store-hours-button {\r\n  padding: 8px 15px;\r\n  background: #0077cc;\r\n  border: none;\r\n  color: white;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.store-hours-button:hover {\r\n  background: #005fa3;\r\n}\r\n\r\n.store-hours-delete {\r\n  padding: 5px 10px;\r\n  background: #d9534f;\r\n  border: none;\r\n  color: white;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  margin-left: 10px;\r\n}\r\n\r\n.store-hours-delete:hover {\r\n  background: #c9302c;\r\n}\r\n\r\n.store-hours-list {\r\n  list-style: none;\r\n  padding: 0;\r\n}\r\n\r\n.store-hours-item {\r\n  margin-bottom: 15px;\r\n  padding-bottom: 10px;\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n\r\n.store-hours-breaks {\r\n  margin-top: 10px;\r\n}\r\n\r\n.store-hours-breaks small {\r\n  font-weight: 600;\r\n}\r\n\r\n.store-hours-breaks ul {\r\n  padding-left: 20px;\r\n  margin-top: 5px;\r\n}\r\n\r\n.store-hours-radio {\r\n  margin-top: 8px;\r\n  display: block;\r\n}\r\n.store-hours-container {\r\n  padding: 0px 0px 0px 20px;\r\n}\r\n\r\n.store-hours-section {\r\n  margin-bottom: 30px;\r\n  background: #fafafa;\r\n  padding: 15px;\r\n  border-radius: 8px;\r\n  border: 1px solid #ddd;\r\n}\r\n\r\n.store-hours-input {\r\n  margin-bottom: 10px;\r\n  padding: 5px;\r\n  border-radius: 4px;\r\n  border: 1px solid #ccc;\r\n}\r\n\r\n.store-hours-button {\r\n  margin-top: 10px;\r\n  padding: 8px 15px;\r\n  background: #1677ff;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n}\r\n\r\n.store-hours-button:hover {\r\n  background: #125fcc;\r\n}\r\n\r\n.store-hours-list {\r\n  list-style: none;\r\n  padding: 0;\r\n}\r\n\r\n.store-hours-item {\r\n  margin-bottom: 15px;\r\n  padding: 10px;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.store-hours-delete {\r\n  margin-left: 10px;\r\n  background: #ff4d4f;\r\n  color: white;\r\n  border: none;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.store-hours-delete:hover {\r\n  background: #d9363e;\r\n}\r\n\r\n.store-hours-summary {\r\n  list-style: none;\r\n  padding: 0;\r\n}\r\n\r\n.store-hours-summary > li {\r\n  margin-bottom: 10px;\r\n}\r\n.store-hours-form-container {\r\n  display: flex;\r\n  gap: 10px;           /* Espaço entre as seções */\r\n  flex-wrap: wrap;     /* Permite quebrar linha se necessário */\r\n  padding-right: 10px;\r\n}\r\n\r\n.store-hours-section {\r\n  flex: 1 1 300px;    /* Cresce e encolhe, largura base 300px */\r\n  min-width: 280px;   /* Para não ficar muito pequeno */\r\n}\r\n\r\n/* Mobile: empilha as seções verticalmente */\r\n@media (max-width: 600px) {\r\n  .store-hours-form-container {\r\n    flex-direction: column;\r\n  }\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
